export enum Controls{
    B = 'strong',
    I = 'em',
    U = 'u',
    Strike = 'del',
    Sub = 'sub',
    Sup =  'sup',
    Fore = 'span',
    Back = 'span',
    Personalization = 'pers',
    Smile = 'smile'
  }
  
  export enum ControlClasses {
    B = 'bold',
    I = 'itallic',
    U = 'underline',
    Strike = 'strikethrough',
    Sub = 'sub',
    Sup =  'sup',
    Fore = 'color',
    Back = 'bgcolor',
  }
  